'use client';
import { createComponent } from '../core/create-component.js';
import { deprecatedComponent } from '../core/deprecated-component.js';

let e = createComponent({
    displayName: 'ThumbnailsHeroContent',
    root: 'div',
    propConfig: {
        classNames: [
            'swan-thumbnails-hero-content'
        ]
    }
});
const ThumbnailsHeroContent = deprecatedComponent({
    description: 'Remove any content and use only an image',
    displayName: 'ThumbnailsHeroContent',
    root: e
});

export { ThumbnailsHeroContent };
